import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe, AuthFacade, ResourcesService, UserPermission } from '@mitsubishi/core';
import { DatasheetFacade } from '@mitsubishi/project/data-access';
import { ConfigurationAlertsDialogComponent } from '@mitsubishi/project/shared';
import { PerformanceMessage } from '@mitsubishi/shared/data-access';
import { IconComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';
import { DialogService } from '@mitsubishi/ui/dialog';

import { FieldWrapper, FormlyField } from '@ngx-formly/core';

@Component({
  selector: 'apm-headless-table-wrapper',
  templateUrl: './headless-table-wrapper.component.html',
  styleUrls: ['./headless-table-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass, FormlyField, SectionTitleComponent, ApmTranslatePipe, MatTooltip, IconComponent],
})
export class HeadlessTableWrapperComponent extends FieldWrapper implements OnInit {
  hasDatasheetMoreDetailsPermission = inject(AuthFacade).hasPermission(UserPermission.DatasheetMoreDetails);
  dialogService = inject(DialogService);
  resourcesService = inject(ResourcesService);
  datasheetFacade = inject(DatasheetFacade);

  selectedRow$ = this.datasheetFacade.selectedRow$;
  isEditing$ = this.datasheetFacade.isEditing$;

  isFirst;

  ngOnInit() {
    this.isFirst = this.field?.parent?.fieldGroup?.findIndex(f => f.key === this.field.key) === 0;
  }

  setSelectedRow($event: MouseEvent, key?: any) {
    $event.stopPropagation();
    this.datasheetFacade.setSelectedRow(key);
  }

  showErrorMessages(errorsResource: number[]) {
    const errorMessages: PerformanceMessage[] = errorsResource.map((error: any) => {
      return {
        code: '',
        description: '',
        descriptionId: error.id,
        messageType: 2,
        parameters: [error.performanceValue, error.performanceUserValue],
      };
    });

    const data = {
      messages: errorMessages,
      title: this.resourcesService.getTextResource('445235'),
    };
    this.dialogService.openDialog(ConfigurationAlertsDialogComponent, 'md', data);
  }
}
